import { Put } from "../http/httpVerbs";

export const apiPostRemovePontuacaoDesafio = async (postId, desafiocreator) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/posts/${postId}/removerdesafio/${desafiocreator}`;
        const response = await Put(url);
        return response;
    } catch (error) {
        console.error("API apiPostRemovePontuacaoDesafio ERROR:", error);
        throw error;
    }
};
